import _defineProperty from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Logger } from '@anm/helpers/Debugger';
import * as Sentry from '@sentry/react';
import isServer from '../is/isServer';
import isUnitTesting from '../testing/isUnitTesting';
var env = process.env.TS_ENV;
var build = process.env.BUILD_NUMBER;

if (!isServer()) {
  window['build'] = process.env.BUILD_NUMBER;
}

var isEnabled = (env === 'test' || env === 'prod') && !isUnitTesting();
var logger = new Logger('Sentry');

var errorHandler = function errorHandler() {
  var msg = '';

  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  for (var _i = 0, _args = args; _i < _args.length; _i++) {
    var a = _args[_i];

    if (a instanceof Error) {
      var _e$message;

      var e = a; // attempt to disable this netxjs bug https://wavevideo.sentry.io/issues/4186766449/events/4fea005a1d11482eaff7e20f651b6448/?project=4503898148438016

      if ((_e$message = e.message) !== null && _e$message !== void 0 && _e$message.includes("(evaluating 'c.tagName')")) return;
      Sentry.setExtra('exceptionMessage', msg);
      Sentry.captureException(e);
      return;
    } else if (typeof a !== 'object') {
      msg += a;
    } else {
      try {
        msg += ' ' + JSON.stringify(a);
      } catch (e) {
        msg += ' ' + a;
      }
    }
  }

  Sentry.captureMessage(msg);
};

var defaultIntegrations = [new Sentry.Integrations.TryCatch(), new Sentry.Integrations.Dedupe()];
export var init = function init(_ref) {
  var dsn = _ref.dsn,
      release = _ref.release,
      _ref$integrations = _ref.integrations,
      integrations = _ref$integrations === void 0 ? defaultIntegrations : _ref$integrations,
      others = _objectWithoutProperties(_ref, ["dsn", "release", "integrations"]);

  if (!isEnabled) return;

  try {
    Sentry.init(_objectSpread({
      dsn: dsn,
      integrations: integrations,
      release: "".concat(release, "-").concat(env, "#").concat(build),
      environment: "".concat(env),
      maxValueLength: 1024
    }, others));
  } catch (err) {
    logger.error(err);
    return;
  }

  Logger.errorHandler = errorHandler;
};
export var setUser = function setUser(userProfile) {
  if (isEnabled && userProfile) {
    var email = userProfile.email,
        username = userProfile.username,
        userId = userProfile.userId;
    Sentry.setUser({
      email: email,
      username: username,
      id: userId
    });
  }
};